import { useState, useEffect } from "react";
import styles from "./ListNotifications.module.scss";
import Pagination from "@mui/material/Pagination";
import CircularProgress from "@mui/material/CircularProgress";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import { BiCheck } from "react-icons/bi";
import {
  AiOutlineFile,
  AiOutlineFileSync,
  AiOutlineFileSearch,
  AiOutlineFileExclamation,
  AiOutlineFileDone,
} from "react-icons/ai";
import {
  BiCalendarAlt,
  BiCalendarCheck,
  BiCalendarEdit,
  BiCalendarMinus,
  BiCalendarPlus,
  BiCalendarExclamation,
} from "react-icons/bi";
export default function ListNotifications({ data, index, action }) {
  function leftReturn(StartDate) {
    // The number of milliseconds in all UTC days (no DST)
    const oneDay = 1000 * 60 * 60 * 24;
    const oneHour = 1000 * 60 * 60;
    const oneMinute = 1000 * 60;
    StartDate = new Date(StartDate);
    let nowDate = new Date();

    // A day in UTC always lasts 24 hours (unlike in other time formats)
    const now = Date.UTC(
      nowDate.getFullYear(),
      nowDate.getMonth(),
      nowDate.getDate(),
      nowDate.getHours(),
      nowDate.getMinutes()
    );
    const start = Date.UTC(
      StartDate.getFullYear(),
      StartDate.getMonth(),
      StartDate.getDate(),
      StartDate.getHours(),
      StartDate.getMinutes()
    );

    // so it's safe to divide by 24 hours
    let leftDays = Math.floor((now - start) / oneDay);
    let leftHours = Math.floor((now - start) / oneHour);
    let leftMinutes = Math.floor((now - start) / oneMinute);
    return leftDays < 1 ? (
      leftHours < 1 ? (
        leftMinutes < 1 ? (
          <span className={styles.left}>
            mniej niż
            <span style={{ fontWeight: "700" }}> minute </span>
            temu
          </span>
        ) : leftMinutes === 1 ? (
          <span className={styles.left}>
            <span style={{ fontWeight: "700" }}>{leftMinutes}</span> minutę temu
          </span>
        ) : leftMinutes > 1 && leftMinutes < 5 ? (
          <span className={styles.left}>
            <span style={{ fontWeight: "700" }}>{leftMinutes}</span> minuty temu
          </span>
        ) : (
          <span className={styles.left}>
            <span style={{ fontWeight: "700" }}>{leftMinutes}</span> minut temu
          </span>
        )
      ) : leftHours === 1 ? (
        <span className={styles.left}>
          <span style={{ fontWeight: "700" }}>{leftHours}</span> godzinę temu
        </span>
      ) : leftHours > 1 && leftHours < 5 ? (
        <span className={styles.left}>
          <span style={{ fontWeight: "700" }}>{leftHours}</span> godziny temu
        </span>
      ) : (
        <span className={styles.left}>
          <span style={{ fontWeight: "700" }}>{leftHours}</span> godzin temu
        </span>
      )
    ) : leftDays === 1 && leftDays ? (
      <span className={styles.left}>
        <span style={{ fontWeight: "700" }}>{leftDays}</span> dzień temu
      </span>
    ) : leftDays > 1 && leftDays < 5 ? (
      <span className={styles.left}>
        <span style={{ fontWeight: "700" }}>{leftDays}</span> dni temu
      </span>
    ) : (
      <span className={styles.left}>
        <span style={{ fontWeight: "700" }}>{leftDays}</span> dni temu
      </span>
    );
  }
  const icons = [
    <AiOutlineFile />, // zwykłe
    <AiOutlineFile />, //Dodano umowę
    <AiOutlineFile />, //Usunięto umowę
    <AiOutlineFileSync />, //Zaktualizowano umowę
    <AiOutlineFileSearch />, //Umowa oczekuję na weryfikacje
    <AiOutlineFileSearch />, //Umowa oczekuję na akceptację
    <AiOutlineFileSearch />, //Umowa oczekuje na poprawę
    <AiOutlineFileExclamation />, //Kończąca się umowa
    <AiOutlineFile />, //Spadek obrotu
    <BiCalendarPlus />, //Dostałeś nowe zadanie
    <BiCalendarMinus />, //Usunięto zadanie
    <BiCalendarEdit />, //Zaktualizowano twoje zadanie
    <BiCalendarCheck />, //Zakończono twoje zadanie
    <BiCalendarExclamation />, //Nadchodzi wydarzenie
  ];
  return (
    <div className={styles.notificationsWrapper}>
      {data !== null ? (
        data.length > 0 ? (
          data.map((item, i) => {
            return (
              <div key={i} className={styles.notification}>
                <div className={styles.iconWrapper}>
                  {icons[item.notification_type_id - 1]}
                </div>
                <div className={styles.right}>
                  <span style={index === 0 ? { fontWeight: "500" } : {}}>
                    {item.name}
                  </span>
                  <div className={styles.bottom}>
                    <span>
                      {item.creation_date !== null &&
                        leftReturn(item.creation_date)}
                    </span>
                    <span>{item.event_type_name}</span>
                  </div>
                </div>
                {index === 0 && (
                  <Tooltip
                    onClick={() => {
                      action("mark", item.event_notification_id);
                    }}
                    style={{ marginLeft: "auto" }}
                    title="Oznacz jako przeczytane"
                    arrow
                    placement="top"
                  >
                    <IconButton>
                      <BiCheck />
                    </IconButton>
                  </Tooltip>
                )}
              </div>
            );
          })
        ) : (
          <div style={{ padding: "15px" }}>
            Nie masz żadnych {index === 0 && "nowych"} powiadomień
          </div>
        )
      ) : (
        <div style={{ padding: "15px" }}>
          <CircularProgress />
        </div>
      )}
    </div>
  );
}
